import { useApiData } from "@/hooks/useApiData";
import { FileText, FolderOpen, MessageSquare, Users, Inbox } from "lucide-react";
import { Link } from "wouter";

export default function Dashboard() {
  const { data: posts } = useApiData<any[]>("/blog-posts");
  const { data: projects } = useApiData<any[]>("/projects");
  const { data: testimonials } = useApiData<any[]>("/testimonials");
  const { data: clients } = useApiData<any[]>("/clients");
  const { data: leads } = useApiData<any[]>("/contact-submissions");

  const newLeads = Array.isArray(leads) ? leads.filter((l: any) => l.status === "new").length : 0;

  const stats = [
    { label: "Blog Posts", count: posts?.length ?? 0, icon: FileText, href: "/admin/blog-posts", color: "from-blue-500/20 to-blue-600/10" },
    { label: "Projects", count: projects?.length ?? 0, icon: FolderOpen, href: "/admin/projects", color: "from-purple-500/20 to-purple-600/10" },
    { label: "Testimonials", count: testimonials?.length ?? 0, icon: MessageSquare, href: "/admin/testimonials", color: "from-amber-500/20 to-amber-600/10" },
    { label: "Clients", count: clients?.length ?? 0, icon: Users, href: "/admin/clients", color: "from-emerald-500/20 to-emerald-600/10" },
    { label: "Leads", count: Array.isArray(leads) ? leads.length : 0, badge: newLeads > 0 ? `${newLeads} new` : undefined, icon: Inbox, href: "/admin/leads", color: "from-rose-500/20 to-rose-600/10" },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold text-white font-[Rubik] mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat) => (
          <Link
            key={stat.href}
            href={stat.href}
            className={`block p-6 rounded-2xl border border-white/5 bg-gradient-to-br ${stat.color} hover:border-white/10 transition-colors`}
          >
            <stat.icon className="w-8 h-8 text-white/30 mb-3" />
            <div className="text-3xl font-bold text-white font-[Rubik]">{stat.count}</div>
            <div className="text-sm text-white/50 mt-1 flex items-center gap-2">
              {stat.label}
              {(stat as any).badge && (
                <span className="bg-blue-500/20 text-blue-400 text-xs font-bold px-1.5 py-0.5 rounded-full">
                  {(stat as any).badge}
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
